import {api} from './base';
import {handleApiError} from './util';
import {ApiResponse} from "../types/response";
import {NotificationResponseData} from "../types/notification";

export const getNotificationAPI = async (): Promise<NotificationResponseData[]> => { //사용자 푸시 전체 조회 API 호출
    try {
        const response = await api.get<ApiResponse<NotificationResponseData[]>>
        (`/notification/all`);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const setReadNotificationAPI = async (notificationId: number): Promise<void> => { //사용자 푸시 읽음 처리 API 호출
    try {
        const response = await api.patch<ApiResponse<void>>
        (`/notification/read?notificationId=${notificationId}`);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const setReadAllNotificationAPI = async (): Promise<void> => { //사용자 푸시 전체 읽음 처리 API 호출
    try {
        const response = await api.patch<ApiResponse<void>>
        (`/notification/read/all`);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const checkNotificationAPI = async (): Promise<number> => { //사용자 안 읽은 푸시 개수 조회 API 호출
    try {
        const response = await api.get<ApiResponse<number>>
        (`/notification/check`);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}